import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/step-reduce.png'
import _imports_1 from '@/assets/icon/add.png'


const _withScopeId = n => (_pushScopeId("data-v-4e98168b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stepper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export interface IProps {
    modelValue: number;
    max?: number;
    min?: number;
  }
  export interface IEmits {
    (event: 'update:modelValue', value: number): void;
    (event: 'change', value: number): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { default: 0 },
    max: { default: Number.MAX_SAFE_INTEGER },
    min: { default: 1 }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', value: number): void;
    (event: 'change', value: number): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number, max: number, min: number }

  
  

  function add() {
    const val = Math.min(props.modelValue + 1, props.max);
    emits('update:modelValue', val);
    emits('change', val);
  }

  function minus() {
    const val = Math.max(props.modelValue - 1, props.min);
    emits('update:modelValue', val);
    emits('change', val);
  }

  function input(e: Event) {
    const target = (<HTMLInputElement>e.target);
    const value = Number(target.value) || 0;
    const val = Math.min(Math.max(value, props.min));
    emits('update:modelValue', val);
    emits('change', val);
    target.value = String(val);
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "btn-minus",
      onClick: minus
    }, _hoisted_3),
    _createElementVNode("input", {
      value: __props.modelValue,
      onInput: input
    }, null, 40, _hoisted_4),
    _createElementVNode("div", {
      class: "btn-plus",
      onClick: add
    }, _hoisted_6)
  ]))
}
}

})